// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1xvSn","header":"ClearentDisclaimer_header__25qyK","inner":"ClearentDisclaimer_inner__1mSne"};